/** A screen: a remote training. */
export const MonitorIcon: React.FC = () => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="16"
		height="16"
		viewBox="0 0 16 16"
		fill="none"
	>
		<rect
			x="1.5"
			y="2.5"
			width="13"
			height="8.5"
			rx="1.5"
			stroke="currentColor"
			strokeWidth="1.5"
		/>
		<path
			d="M5.5 14h5M8 11v3"
			stroke="currentColor"
			strokeWidth="1.5"
			strokeLinecap="round"
		/>
	</svg>
)
